/**
 * Normalize user profile roles from API to string[] (role names).
 * API returns array of UserRoleAssignmentDto with roleName; we may also receive string[].
 * Use this so AuthContext user.roles and ActiveRoleContext always get DB role names.
 */
export function normalizeProfileRoles(roles: unknown): string[] {
  if (!roles || !Array.isArray(roles)) return [];
  return roles
    .map((role: unknown) => {
      if (typeof role === 'string') return role.trim();
      if (role && typeof role === 'object') {
        const r = role as { roleName?: string; name?: string; role?: string; code?: string; roleCode?: string };
        return (r.roleName ?? r.name ?? r.role ?? r.roleCode ?? r.code ?? '').trim();
      }
      return '';
    })
    .filter(Boolean);
}
